import { BaseInput } from "./BaseInput";
import { useState } from "react";

const BORDER_STYLES = {
  default: "2px solid #333",
  correct: "2px solid #2e7d32",     // green
  incorrect: "2px solid #c62828",   // red
  disabled: "2px solid #999",
  none: "none",
};

function applyCase(s, normalizeCase = "upper") {
  if (normalizeCase === "lower") return s.toLowerCase();
  if (normalizeCase === "none") return s;
  return s.toUpperCase();
}

function normalizePitchNameInput(input, normalizeCase = "upper") {
  if (!input) return "";

  const s = input
    .trim()
    .replace(/♭/g, "b")
    .replace(/♯/g, "#")
    .replace(/♮/g, "");

  const m = s.match(/^([A-Ga-g])([#b]{0,2})$/);
  if (!m) return applyCase(s, normalizeCase);

  return applyCase(m[1], normalizeCase) + m[2];
}

function insertAccidental(value, accGlyph) {
  return value + accGlyph;
  const normalized = normalizePitchNameInput(value || "");
  const m = normalized.match(/^([A-G])([#b]{0,2})$/);

  if (!m) return normalizePitchNameInput(accGlyph);
  return normalizePitchNameInput(m[1] + accGlyph);
}

function AccidentalButtons({ onSelect }) {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {[
        { label: "♭", value: "♭" },
        { label: "♯", value: "♯" }
      ].map(({ label, value }) => (
        <button
          key={value}
          tabIndex={-1}
          style={{
            fontSize: 16,
            padding: "2px 6px",
            cursor: "pointer"
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(value);
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

// export default function NumberInput({
//   value,
//   onChange,
//   border = "default",
//   disabled = false,
//   cid = ""
// }) {
//   return (
//     <BaseInput
//       value={value}
//       onChange={onChange}
//       placeholder=""
//       inputMode="numeric"
//       pattern="[0-9]*"
//       disabled={disabled}
//       style={{
//         width: cid.indexOf("b")!=-1 ? "35px" : "49px",
//         height: "45px",
//         padding: "0",
//         textAlign: "center",
//         fontSize: "20px",
//         border: BORDER_STYLES[border] ?? BORDER_STYLES.default,
//         borderRadius: "4px",
//         backgroundColor: "#fff",
//       }}
//     />
//   );
// }

export default function DiagramNumberInput({
  value = "",
  onChange,
  disabled,
  border = "default",
  allowAccidentals = false,
  accidentalsRight = false,   // ← NEW
  normalizeCase = "upper"
}) {
  const [focused, setFocused] = useState(false);

  function popupStyle() {
    if (accidentalsRight) {
      return {
        position: "absolute",
        left: "100%",
        top: "50%",
        marginLeft: 6,
        transform: "translateY(-50%)",
        zIndex: 10000
      };
    }

    // default: below
    return {
      position: "absolute",
      top: "100%",
      left: 0,
      marginTop: 4,
      zIndex: 10000
    };
  }

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        value={value}
        disabled={disabled}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        // onChange={(e) =>
        //   onChange(
        //     allowAccidentals
        //       ? normalizePitchNameInput(e.target.value)
        //       : e.target.value.replace(/\D/g, "")
        //   )
        // }
        onChange={(e) => {
          const raw = e.target.value;

          if (!allowAccidentals) {
            const cased = applyCase(raw, normalizeCase);

            if (cased === "X" || cased === "x") {
              onChange(cased);
              return;
            }

            onChange(cased.replace(/\D/g, ""));
            return;
          }

          onChange(normalizePitchNameInput(raw, normalizeCase));
        }}

        style={{
          width: 40,
          height: 40,
          textAlign: "center",
          fontSize: 16,
          borderRadius: 6,
          border:
            border === "correct"
              ? "2px solid #2e7d32"
              : border === "incorrect"
              ? "2px solid #c62828"
              : "1px solid #aaa"
        }}
      />

      {allowAccidentals && focused && !disabled && (
        <div
          style={{
            ...popupStyle(),
            background: "#fff",
            border: "1px solid #aaa",
            borderRadius: 6,
            padding: "0px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
            pointerEvents: "auto"
          }}
        >
          <AccidentalButtons
            onSelect={(acc) =>
              onChange(insertAccidental(value, acc))
            }
          />
        </div>
      )}

    </div>
  );
}
